/** 审批业务大类（与后端 workflowDefaults.WF_BIZ_CATEGORIES 保持一致） */
export const WF_BIZ_CATEGORIES = {
  hr_admin: { label: '人力行政类', order: 1 },
  finance: { label: '财务管理类', order: 2 },
  plan_mgmt: { label: '计划管理类', order: 3 },
  quality: { label: '品质运营类', order: 4 },
  marketing: { label: '营销管理类', order: 5 },
  tech: { label: '科技信息类', order: 6 }
};

export const WF_BIZ_TYPES = [
  { value: 'onboarding', label: '入职审批', color: '#1677ff', category: 'hr_admin', hiddenInitiate: true },
  { value: 'regularization', label: '转正审批', color: '#722ed1', category: 'hr_admin', hiddenInitiate: true },
  { value: 'transfer', label: '异动审批', color: '#13c2c2', category: 'hr_admin', hiddenInitiate: true },
  { value: 'resignation', label: '离职审批', color: '#fa8c16', category: 'hr_admin', hiddenInitiate: true },
  { value: 'company_cert_change', label: '公司资质变更', color: '#389e0d', category: 'hr_admin' },
  { value: 'company_cert_borrow', label: '公司资质借阅申请', color: '#597ef7', category: 'hr_admin' },
  { value: 'company_deregistration', label: '公司注销申请', color: '#cf1322', category: 'hr_admin' },
  { value: 'contract_approval', label: '合同审批', color: '#9254de', category: 'hr_admin' },
  { value: 'seal_other_approval', label: '其他用印文件审批', color: '#531dab', category: 'hr_admin' },
  { value: 'plan_org_due_extension', label: '公司重点事项延期', color: '#d48806', category: 'plan_mgmt', hiddenInitiate: true },
  { value: 'expense_daily', label: '费用报销', color: '#eb2f96', category: 'finance' },
  { value: 'severance_compensation', label: '经济补偿金', color: '#c41d7f', category: 'hr_admin' },
  { value: 'overtime_apply', label: '加班申请', color: '#fa541c', category: 'hr_admin' }, // scaffold: overtime_apply
  { value: 'outside_apply', label: '外出申请', color: '#13c2c2', category: 'hr_admin' }, // scaffold: outside_apply
  { value: 'business_trip_apply', label: '出差申请', color: '#1677ff', category: 'hr_admin' }, // scaffold: business_trip_apply
  { value: 'makeup_apply', label: '异常考勤修正', color: '#722ed1', category: 'hr_admin' }, // scaffold: makeup_apply
  { value: 'leave_apply', label: '请假申请', color: '#1677ff', category: 'hr_admin' }, // scaffold: leave_apply
  { value: 'budget_adjustment', label: '预算调整申请', color: '#1677ff', category: 'finance' }, // scaffold: budget_adjustment
  { value: 'exp_prepayment', label: '预付款/借款申请', color: '#1677ff', category: 'finance' }, // scaffold: exp_prepayment
  { value: 'exp_prepayment_writeoff', label: '预付款/借款核销', color: '#1677ff', category: 'finance', hiddenInitiate: true }, // scaffold: exp_prepayment_writeoff
  { value: 'expense_prepayment_append', label: '追加报销', color: '#eb2f96', category: 'finance', hiddenInitiate: true },
  { value: 'exp_prepayment_adjust', label: '预付款/借款金额调整', color: '#1677ff', category: 'finance', hiddenInitiate: true }, // scaffold: exp_prepayment_adjust
  { value: 'regularization_delay', label: '入职延期申请', color: '#1677ff', category: 'hr_admin', hiddenInitiate: true }, // scaffold: regularization_delay
  { value: 'fin_internal_fund_transfer', label: '内部资金调拨', color: '#1677ff', category: 'finance' }, // scaffold: fin_internal_fund_transfer
  { value: 'fin_social_fund_payment', label: '社保/公积金付款审批', color: '#1677ff', category: 'finance' }, // scaffold: fin_social_fund_payment
  { value: 'hr_social_insurance_change', label: '社保购买/减少', color: '#1677ff', category: 'hr_admin' } // scaffold: hr_social_insurance_change
];

export const WF_NODE_TYPES = [
  { value: 'start', label: '发起', addable: false },
  { value: 'approver', label: '审批人', addable: true },
  { value: 'cc', label: '抄送人', addable: true },
  { value: 'executor', label: '执行人', addable: true },
  { value: 'condition', label: '条件分支', addable: true },
];

export const WF_ASSIGNEE_TYPES = [
  { value: 'user', label: '指定成员' },
  { value: 'initiator_select', label: '发起人自选' },
  { value: 'role', label: '指定角色' },
  { value: 'org_leader', label: '部门主管' },
  { value: 'direct_manager', label: '直接上级' },
  { value: 'manager_level', label: '连续多级主管' },
  { value: 'initiator', label: '发起人本人' },
  { value: 'form_user_field', label: '表单人员字段' },
];

export const WF_MULTI_MODES = [
  { value: 'or', label: '或签' },
  { value: 'and', label: '会签' },
  { value: 'sequential', label: '依次审批' },
];

export const WF_EMPTY_APPROVER_ACTIONS = [
  { value: 'skip', label: '自动跳过节点' },
  { value: 'admin', label: '转交给应用主管理员' },
  { value: 'assign_user', label: '转交给指定成员' },
  { value: 'pause', label: '流程暂停（即不允许为空）' },
];

export const WF_RETURN_MODES = [
  { value: 'sequential', label: '按流程依次审批' },
  { value: 'direct', label: '跨过中间流程' }
];

export const WF_ADD_SIGN_OPTIONS = [
  { value: 'pre', label: '前加签' },
  { value: 'post', label: '后加签' },
];

export const WF_CONDITION_OPS_TEXT = [
  { value: 'eq', label: '等于' },
  { value: 'neq', label: '不等于' },
  { value: 'contains', label: '包含' },
];

export const WF_CONDITION_OPS_COMPARE = [
  { value: 'eq', label: '等于' },
  { value: 'neq', label: '不等于' },
  { value: 'gt', label: '大于' },
  { value: 'gte', label: '大于等于' },
  { value: 'lt', label: '小于' },
  { value: 'lte', label: '小于等于' },
];

export function getConditionOpsForType(type) {
  if (type === 'number' || type === 'date') return WF_CONDITION_OPS_COMPARE;
  return WF_CONDITION_OPS_TEXT;
}

export function getConditionValuePlaceholder(type) {
  if (type === 'date') return 'YYYY-MM-DD';
  if (type === 'number') return '数字';
  return '值';
}

export function getBizCategoryMeta(category) {
  return WF_BIZ_CATEGORIES[category] || { label: '其他', order: 99 };
}

export function getBizMeta(bizType) {
  return WF_BIZ_TYPES.find((b) => b.value === bizType) || { label: bizType };
}
